export default __webpack_public_path__ + "static/media/amazon.09addc71.svg";